export enum CaseType {
  ems = "emsED",
  hospital = "hospitalED",
  ift = "ift",
  mih = "mih",
}
